import { LAYOUT_COMPONENT_TYPE, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const footerStandardDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.footer,
  componentType: LAYOUT_COMPONENT_TYPE.footerStandard,
  displayOrder: 99,
  content: {
    siteTitle: loc3('Trattoria Aurora', 'Trattoria Aurora', 'Trattoria Aurora'),
    address: loc3('12 Via Roma, 20121 Milano', '12 Via Roma, 20121 Milano', '12 Via Roma, 20121 Milano'),
    phone: loc3('+49 89 1234567', '+49 89 1234567', '+49 89 1234567'),
    email: loc3('hello@example.com', 'hello@example.com', 'hello@example.com'),
    hours: loc3(
      'Mo–Fr 09:00–12:00, 14:00–19:00\nSa–So geschlossen',
      'Mon–Fri 09:00–12:00, 14:00–19:00\nSat–Sun closed',
      'Thứ Hai - Thứ Sáu 09:00 - 12:00\n09:00 - 19:00\nThứ Bảy - Chủ Nhật Đóng cửa',
    ),
    legalLine: loc3(
      '© 2026 Trattoria Aurora. Alle Rechte vorbehalten.',
      '© 2026 Trattoria Aurora. All rights reserved.',
      '© 2026 Trattoria Aurora. Bảo lưu mọi quyền.',
    ),
  },
  media: {},
};
